const THEME_KEY = "rifa365_adm_theme";
const SIDEBAR_KEY = "rifa365_adm_sidebar";

export function readThemePreference() {
  try {
    return localStorage.getItem(THEME_KEY) === "dark";
  } catch {
    return false;
  }
}

export function readSidebarLightPreference() {
  try {
    return localStorage.getItem(SIDEBAR_KEY) === "light";
  } catch {
    return false;
  }
}

export function persistThemePreference(isDark) {
  try {
    localStorage.setItem(THEME_KEY, isDark ? "dark" : "light");
  } catch {
    /* ignore */
  }
}

export function persistSidebarLightPreference(isLight) {
  try {
    localStorage.setItem(SIDEBAR_KEY, isLight ? "light" : "dark");
  } catch {
    /* ignore */
  }
}

/** Applies Soft UI + PrimeVue dark classes on document.body */
export function applyThemeClasses(isDark) {
  if (typeof document === "undefined") return;
  const body = document.body;
  if (!body) return;
  body.classList.toggle("dark-version", !!isDark);
  body.classList.toggle("my-app-dark", !!isDark);
  body.classList.toggle("bg-gray-200", !isDark);
}
